import * as Yup from 'yup';

import { NO_LEADING_TRAILING_SPACES_VALIDATION } from '@/shared/consts';

export const REJECT_APPLICATION_VALIDATION_SCHEMA = Yup.object().shape({
  reason: NO_LEADING_TRAILING_SPACES_VALIDATION.required('Обязательное поле').max(
    500,
    'Превышено допустимое количество символов',
  ),
});
